var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import React__default, { useEffect } from "react";
import logger, { ErrorType } from "@ane/core/lib/services/logging/Logger";
import "../MessageBar/index.js";
import "../Button/index.js";
import "../../Styling.js";
import { IconButton } from "../Button/IconButton.js";
import { MessageBarType } from "@fluentui/react/lib/MessageBar";
import { getTheme, IconFontSizes, HighContrastSelector, getHighContrastNoAdjustStyle, getFocusStyle, mergeStyles } from "@fluentui/style-utilities";
import { MessageBar } from "../MessageBar/MessageBar.js";
const RetryButton = ({ onRetry }) => !!onRetry ? /* @__PURE__ */ jsx(
  IconButton,
  {
    ariaLabel: "Retry",
    iconProps: {
      iconName: "Refresh"
    },
    styles: {
      root: {
        width: "auto",
        height: "16px",
        lineHeight: "16px"
      }
    },
    onClick: onRetry,
    children: "Reload"
  }
) : null;
const ErrorMessage = ({
  children,
  heading = "Error:",
  message = "An unknown error occured",
  messageBarProps,
  onRetry,
  onDismiss,
  loggingProps = {}
}) => {
  const _a = messageBarProps || {}, { actions, messageBarType = MessageBarType.error } = _a, rest = __objRest(_a, ["actions", "messageBarType"]);
  const [isExpanded, setExpanded] = React__default.useState(true);
  const theme = getTheme();
  const { semanticColors } = theme;
  const dismissalAndExpandIconStyle = {
    fontSize: IconFontSizes.xSmall,
    height: 10,
    lineHeight: "10px",
    color: semanticColors.messageText,
    selectors: {
      [HighContrastSelector]: __spreadProps(__spreadValues({}, getHighContrastNoAdjustStyle()), {
        color: "WindowText"
      })
    }
  };
  const dismissalAndExpandStyle = [
    getFocusStyle(theme, {
      inset: 1,
      highContrastStyle: {
        outlineOffset: "-6px",
        outline: "1px solid Highlight"
      },
      borderColor: "transparent"
    }),
    {
      flexShrink: 0,
      width: 32,
      height: 32,
      padding: "8px 12px",
      selectors: {
        "&.ms-Button.ane-IconButton .ms-Button-icon": dismissalAndExpandIconStyle,
        ":hover": {
          backgroundColor: "transparent"
        },
        ":active": {
          backgroundColor: "transparent"
        }
      }
    }
  ];
  useEffect(() => {
    logger.error(message, ErrorType.ControlTowerError, __spreadValues({
      suppressPopup: true
    }, loggingProps));
  }, []);
  const expandIconProps = { iconName: isExpanded ? "DoubleChevronUp" : "DoubleChevronDown" };
  const overflowButtonAriaLabel = isExpanded ? "Collapse" : "Expand";
  return /* @__PURE__ */ jsxs(
    MessageBar,
    __spreadProps(__spreadValues({
      ariaLabel: "",
      isMultiline: isExpanded,
      truncated: !isExpanded,
      onDismiss,
      messageBarType,
      actions: /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          IconButton,
          {
            className: mergeStyles(dismissalAndExpandStyle),
            onClick: () => setExpanded(!isExpanded),
            iconProps: expandIconProps,
            ariaLabel: overflowButtonAriaLabel,
            "aria-expanded": isExpanded
          }
        ),
        /* @__PURE__ */ jsx(RetryButton, { onRetry }),
        actions
      ] }),
      expandButtonProps: {
        ariaLabel: overflowButtonAriaLabel,
        onClick: () => setExpanded(!isExpanded)
      }
    }, rest), {
      children: [
        !!heading && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("strong", { children: heading }),
          !!heading && !!message && " "
        ] }),
        !!children ? children : /* @__PURE__ */ jsx("span", { children: message })
      ]
    })
  );
};
const ValidationMessage = ({
  children,
  heading,
  message,
  messageBarProps,
  loggingProps,
  onRetry,
  onDismiss
}) => {
  const _a = messageBarProps || {}, { actions, messageBarType = MessageBarType.warning } = _a, rest = __objRest(_a, ["actions", "messageBarType"]);
  const [isExpanded, setExpanded] = React__default.useState(false);
  useEffect(() => {
    logger.warn(message, __spreadValues({}, loggingProps));
  }, []);
  return /* @__PURE__ */ jsxs(
    MessageBar,
    __spreadProps(__spreadValues({
      ariaLabel: "",
      isMultiline: isExpanded,
      truncated: !isExpanded,
      onDismiss,
      messageBarType,
      actions: /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(RetryButton, { onRetry }),
        actions
      ] })
    }, rest), {
      onClick: () => setExpanded(!isExpanded),
      children: [
        !!heading && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("strong", { children: heading }),
          !!heading && !!message && " "
        ] }),
        !!children ? children : /* @__PURE__ */ jsx("span", { children: message })
      ]
    })
  );
};
export {
  ErrorMessage,
  RetryButton,
  ValidationMessage
};
//# sourceMappingURL=ErrorMessages.js.map
